import React from 'react';

import MyHealthCardContent from '../MyHealthCardContent';
import SmartLink from '../../SmartLink';

import styles from './index.module.scss';

enum CardType {
  INFO = 'info',
  LINK = 'link'
}

export interface MyHealthCardProps {
  eyebrow: string;
  icon?: React.ReactNode;
  title: string;
  description?: string;
  href: string;
  background: string;
  type: CardType;
  handleInfo: (info: string) => void;
  infoText: string;
}

const MyHealthCard: React.FC<MyHealthCardProps> = ({
  eyebrow,
  icon,
  title,
  description,
  href,
  background,
  type,
  handleInfo,
  infoText
}) => {
  const cardType = {
    [CardType.INFO]: (
      <button onClick={() => handleInfo(infoText)} className={styles.wrapper}>
        <MyHealthCardContent
          eyebrow={eyebrow}
          title={title}
          background={background}
          icon={icon}
          description={description}
        />
      </button>
    ),
    [CardType.LINK]: (
      <SmartLink to={href} className={styles.wrapper}>
        <MyHealthCardContent
          eyebrow={eyebrow}
          title={title}
          background={background}
          icon={icon}
          description={description}
        />
      </SmartLink>
    )
  };

  return <>{cardType[type]}</>;
};

export default MyHealthCard;
